var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-app',{attrs:{"label":_vm.title}},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('about-this-app',{staticClass:"mx-auto"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }